var map = {
	"./Disabled.svg": 2325,
	"./HasWarnings.svg": 2326,
	"./Healthy.svg": 2327,
	"./Unavailable.svg": 2328,
	"./Unhealthy.svg": 2329,
	"./Unknown.svg": 2330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1134;